import { createContext } from 'react'

let AppCtx = createContext({});

export default AppCtx;